export default "__VITE_ASSET__Cvd0zd7V__"